import { render, staticRenderFns } from "./template-activity-edit.vue?vue&type=template&id=2dc7f3aa"
import script from "./template-activity-edit.vue?vue&type=script&lang=js"
export * from "./template-activity-edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports